module.exports = __webpack_public_path__ + "static/media/pores_forehead.41a5d013.svg";